// owned by WP-SEC-UI · the session layer of ECONIC (security §3.3, shell-ia §11): mounted once in app/providers.tsx around the router, so
// it works on every screen and on every shell flag. It draws the idle dialog, the absolute-limit notice and the arrival message, and
// signs out when the server revokes the session (`session.revoked` on the hub). The timers themselves (refresh, idle and absolute
// expiry, other tabs) are the session provider's (@ncp/api-client); `SessionGuard` instances further down render nothing here.
import type { ReactNode } from "react";
import { useAuth, useRealtimeEvent } from "@ncp/api-client";
import { SessionUiProvider } from "@ncp/assistant-sdk";
import { AbsoluteNotice } from "./AbsoluteNotice";
import { IdleDialog } from "./IdleDialog";
import { LastSignInToast } from "./LastSignInToast";

function SessionLayer() {
  const { managed, isAuthenticated, signOut } = useAuth();
  useRealtimeEvent("session.revoked", () => signOut("revoked"), managed);
  if (!isAuthenticated) return null;
  return (
    <>
      <LastSignInToast />
      <AbsoluteNotice />
      <IdleDialog />
    </>
  );
}

export function SessionManager({ children }: { children: ReactNode }) {
  return (
    <SessionUiProvider>
      {children}
      <SessionLayer />
    </SessionUiProvider>
  );
}
